/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React from "react";
import { Button, ButtonToolbar } from "react-bootstrap";

export const ActionsColumnFormatter = (
  cellContent,
  row,
  rowIndex,
  { openReceiptDialog }
) => (
  <>
    <ButtonToolbar className="view-download-btn justify-content-end">
      <Button
        variant="btn btn-light-success font-size-sm"
        onClick={() => {
          openReceiptDialog(row);
        }}
      >
        <i className="fa fa-eye" />
      </Button>
    </ButtonToolbar>
    <> </>
  </>
);
